"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _default = function _default() {
  return (0, _preact.h)("svg", {
    "enable-background": "new 0 0 213.1 213.1",
    viewBox: "0 0 213.1 213.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, (0, _preact.h)("circle", {
    cx: "106.6",
    cy: "106.6",
    fill: "#ffcc4d",
    r: "106.6"
  }), (0, _preact.h)("path", {
    d: "m144.8 123.7c-2 9.5-7.4 17.8-14.8 23.5-6.9 5.3-15.5 8.5-24.8 8.5-9 0-17.4-3-24.1-8-7.8-5.8-13.4-14.3-15.5-24.1h79.2z",
    fill: "#212121"
  }), (0, _preact.h)("path", {
    d: "m130 147.2c-6.9 5.3-15.5 8.5-24.8 8.5-9 0-17.4-3-24.1-8 6.2-6.6 15-10.7 24.7-10.7 9.4.1 18 4 24.2 10.2z",
    fill: "#a3406c"
  }), (0, _preact.h)("g", {
    fill: "#231f20"
  }, (0, _preact.h)("path", {
    d: "m44.5 95.7c-.4 0-.9-.1-1.3-.2-2.7-.7-4.3-3.4-3.6-6.1.4-1.6 1.1-3.2 1.9-4.7 3.6-6.4 10.3-10.3 17.6-10.3 7.2 0 13.9 3.9 17.5 10.1.9 1.5 1.5 3.1 2 4.8.7 2.7-.8 5.4-3.5 6.1s-5.4-.8-6.1-3.5c-.2-.8-.6-1.7-1-2.4-1.8-3.2-5.2-5.1-8.9-5.1s-7.1 2-8.9 5.2c-.4.7-.7 1.5-1 2.4-.4 2.3-2.5 3.7-4.7 3.7z"
  }), (0, _preact.h)("path", {
    d: "m139.2 95.7c-.4 0-.9-.1-1.3-.2-2.7-.7-4.3-3.4-3.6-6.1.4-1.6 1.1-3.2 1.9-4.7 3.6-6.4 10.3-10.3 17.6-10.3 7.2 0 13.9 3.9 17.5 10.1.9 1.5 1.5 3.1 2 4.8.7 2.7-.8 5.4-3.5 6.1s-5.4-.8-6.1-3.5c-.2-.8-.6-1.7-1-2.4-1.8-3.2-5.2-5.1-8.9-5.1s-7.1 2-8.9 5.2c-.4.7-.7 1.5-1 2.4-.4 2.3-2.5 3.7-4.7 3.7z"
  })));
};

exports.default = _default;